import {Injectable} from '@angular/core';
import {BaseProvider} from '../base.provider';
import {BusinessStructureService} from './business-structure.service';

@Injectable()
export class BusinessStructureProvider extends BaseProvider<BusinessStructureInterface[]> {
    public defaultValue = [];

    constructor(
        service: BusinessStructureService
    ) {
        super(service);
        /**
         * Устанавливаем дефолтные значения
         */
        this.data$.next(this.defaultValue);
        this.updateData();
    }

    public getById(id: number): BusinessStructureInterface {
        const list = this.data$.getValue();
        return list.find(item => +item.id === +id);
    }
}

export interface BusinessStructureInterface {
    id: number;
    title: string;
    short_title: string;
}
